export default __webpack_public_path__ + "static/media/Etape8_LesTellieres.6f8316ba.jpg";